import { useTranslation } from 'react-i18next';
import { Industry } from '../../participantEnums';

export const useIndustries = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: Industry.AGRICULTURE_FARMING_RANCHING,
      label: t('participants.enums.industry.AGRICULTURE_FARMING_RANCHING'),
    },
    {
      value: Industry.AGRIFOOD_FOOD_INDUSTRY,
      label: t('participants.enums.industry.AGRIFOOD_FOOD_INDUSTRY'),
    },
    {
      value: Industry.ARCHITECTURE_INTERIORDESIGN,
      label: t('participants.enums.industry.ARCHITECTURE_INTERIORDESIGN'),
    },
    {
      value: Industry.CONSTRUCTION_BTP,
      label: t('participants.enums.industry.CONSTRUCTION_BTP'),
    },
    {
      value: Industry.REAL_ESTATE,
      label: t('participants.enums.industry.REAL_ESTATE'),
    },
    { value: Industry.ENERGY, label: t('participants.enums.industry.ENERGY') },
    {
      value: Industry.INDUSTRY_MANUFACTURING,
      label: t('participants.enums.industry.INDUSTRY_MANUFACTURING'),
    },
    {
      value: Industry.GOODSTRANSPORT_LOGISTICS,
      label: t('participants.enums.industry.GOODSTRANSPORT_LOGISTICS'),
    },
    {
      value: Industry.DISTRIBUTION_MASSRETAILING,
      label: t('participants.enums.industry.DISTRIBUTION_MASSRETAILING'),
    },
    {
      value: Industry.RETAIL_SMALLSCALERETAILING,
      label: t('participants.enums.industry.RETAIL_SMALLSCALERETAILING'),
    },
    {
      value: Industry.ECOMMERCE_MARKETPLACE_ONLINERETAIL,
      label: t(
        'participants.enums.industry.ECOMMERCE_MARKETPLACE_ONLINERETAIL',
      ),
    },
    {
      value: Industry.MOBILITY_TRANSPORTATION,
      label: t('participants.enums.industry.MOBILITY_TRANSPORTATION'),
    },
    {
      value: Industry.TOURISM_HOSPITALITY,
      label: t('participants.enums.industry.TOURISM_HOSPITALITY'),
    },
    {
      value: Industry.RESTAURANT_FOODANDBAVERAGESRETAIL,
      label: t('participants.enums.industry.RESTAURANT_FOODANDBAVERAGESRETAIL'),
    },
    {
      value: Industry.CULTURE_MEDIA_PRESS_ENTERTAINMENT_LEISURE,
      label: t(
        'participants.enums.industry.CULTURE_MEDIA_PRESS_ENTERTAINMENT_LEISURE',
      ),
    },
    {
      value: Industry.FASHION_LUXURY_BEAUTY_LIFESTYLE,
      label: t('participants.enums.industry.FASHION_LUXURY_BEAUTY_LIFESTYLE'),
    },
    {
      value: Industry.HEALTH_MEDICAL_SERVICES_PHARMACEUTICAL,
      label: t(
        'participants.enums.industry.HEALTH_MEDICAL_SERVICES_PHARMACEUTICAL',
      ),
    },
    {
      value: Industry.SOCIAL_ENVIRONMENTAL_PERSONALSERVICES,
      label: t(
        'participants.enums.industry.SOCIAL_ENVIRONMENTAL_PERSONALSERVICES',
      ),
    },
    {
      value: Industry.BANKING_INSURANCE_FINANCE,
      label: t('participants.enums.industry.BANKING_INSURANCE_FINANCE'),
    },
    {
      value: Industry.CONSULTING_AUDIT,
      label: t('participants.enums.industry.CONSULTING_AUDIT'),
    },
    {
      value: Industry.MARKETING_COMMUNICATION_ADVERTISING_DESIGN,
      label: t(
        'participants.enums.industry.MARKETING_COMMUNICATION_ADVERTISING_DESIGN',
      ),
    },
    {
      value: Industry.LEGAL_ACCOUNTING_MANAGEMENT,
      label: t('participants.enums.industry.LEGAL_ACCOUNTING_MANAGEMENT'),
    },
    {
      value: Industry.RECRUITMENT_HR,
      label: t('participants.enums.industry.RECRUITMENT_HR'),
    },
    {
      value: Industry.EDUCATION_TRAINING,
      label: t('participants.enums.industry.EDUCATION_TRAINING'),
    },
    {
      value: Industry.TECH_DIGITAL,
      label: t('participants.enums.industry.TECH_DIGITAL'),
    },
    {
      value: Industry.PUBLIC_ADMINISTRATION,
      label: t('participants.enums.industry.PUBLIC_ADMINISTRATION'),
    },
    {
      value: Industry.ASSOCIATION_NGO,
      label: t('participants.enums.industry.ASSOCIATION_NGO'),
    },
  ];
};
